"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconType = void 0;
/**
 * Use https://icomoon.io/app/ to generate this file.
 */
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var IconType;
(function (IconType) {
    IconType["User"] = "USER";
    IconType["Burger"] = "BURGER";
    IconType["Cross"] = "CROSS";
    IconType["Attachment"] = "ATTACHMENT";
    IconType["Calendar"] = "CALENDAR";
    IconType["Move"] = "MOVE";
    IconType["Reload"] = "RELOAD";
    IconType["Save"] = "SAVE";
    IconType["Download"] = "DOWNLOAD";
    IconType["Pencil"] = "PENCIL";
    IconType["Document"] = "DOCUMENT";
    IconType["Dollar"] = "DOLLAR";
    IconType["Tools"] = "TOOLS";
    IconType["Transport"] = "TRANSPORT";
    IconType["Exit"] = "EXIT";
    IconType["Filter"] = "FILTER";
    IconType["Plus"] = "PLUS";
    IconType["Success"] = "SUCCESS";
    IconType["Warning"] = "WARNING";
    IconType["HelpLight"] = "HELPLIGHT";
    IconType["Search"] = "SEARCH";
    IconType["Help"] = "HELP";
    IconType["Info"] = "INFO";
    IconType["Print"] = "PRINT";
    IconType["Note"] = "NOTE";
    IconType["HelpThin"] = "HELP_THIN";
    IconType["Phone"] = "PHONE";
    IconType["Mail"] = "MAIL";
    IconType["SmileyVeryBad"] = "SMILEYVERYBAD";
    IconType["SmileyBad"] = "SMILEYBAD";
    IconType["SmileyNeutral"] = "SMILEYNEUTRAL";
    IconType["SmileyGood"] = "SMILEYGOOD";
    IconType["SmileyVeryGood"] = "SMILEYVERYGOOD";
    IconType["Spinner"] = "SPINNER";
    IconType["ArrowLeft"] = "ARROW_LEFT";
    IconType["ArrowRight"] = "ARROW_RIGHT";
    IconType["ArrowTop"] = "ARROW_TOP";
    IconType["ArrowBottom"] = "ARROW_BOTTOM";
    IconType["ArrowSubmenu"] = "ARROW_SUBMENU";
    IconType["ArrowTopRight"] = "ARROW_TOP_RIGHT";
    IconType["SortArrowUp"] = "SORT_ARROW_UP";
    IconType["SortArrowDown"] = "SORT_ARROW_DOWN";
    IconType["SortArrowBoth"] = "SORT_ARROW_BOTH";
})(IconType = exports.IconType || (exports.IconType = {}));
// tslint:disable:max-line-length
var ICONS = (_a = {},
    _a[IconType.User] = {
        data: "M8 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0 2c-6.078 0-8 4-8 4v2h16v-2s-1.922-4-8-4z",
        viewBox: "0 0 16 16",
    },
    _a[IconType.Burger] = {
        data: "M0 0v2h24V0H0zm0 7v2h24V7H0zm0 7v2h24v-2H0z",
        viewBox: "0 0 24 16",
    },
    _a[IconType.Cross] = {
        data: "M15.556 14.142l7.071-7.07 1.415 1.413-7.071 7.071 7.07 7.071-1.414 1.415-7.07-7.071-7.072 7.07-1.414-1.414 7.071-7.07-7.07-7.072 1.413-1.414 7.071 7.071z",
        viewBox: "4.5 4.5 22 22",
    },
    _a[IconType.Attachment] = {
        data: "M11 1C8.803 1 7 2.803 7 5v12.5c0 3.026 2.474 5.5 5.5 5.5s5.5-2.474 5.5-5.5V6h-2v11.5c0 1.944-1.556 3.5-3.5 3.5A3.485 3.485 0 0 1 9 17.5V5c0-1.117.883-2 2-2s2 .883 2 2v10.5c0 .287-.213.5-.5.5a.487.487 0 0 1-.5-.5V6h-2v9.5c0 1.37 1.13 2.5 2.5 2.5s2.5-1.13 2.5-2.5V5c0-2.197-1.803-4-4-4z",
        viewBox: "0 0 24 24",
    },
    _a[IconType.Calendar] = {
        data: "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z",
        viewBox: "0 0 24 24",
    },
    _a[IconType.Move] = {
        data: "M0 5h18v2H0V5zm0 4h18v2H0V9zm0 4h18v2H0v-2zM9 0l3 3H6l3-3zm0 20l-3-3h6l-3 3z",
        viewBox: "0 0 18 20",
    },
    _a[IconType.Reload] = {
        data: "M24 12l-4-4-4 4h3c0 3.859-3.14 7-7 7-.88 0-1.72-.17-2.496-.469L7.99 20.047A8.931 8.931 0 0 0 12 21c4.962 0 9-4.037 9-9h3zm-7.99-8.047A8.931 8.931 0 0 0 12 3c-4.962 0-9 4.037-9 9H0l4 4 4-4H5c0-3.859 3.14-7 7-7 .88 0 1.72.17 2.496.469l1.514-1.516z",
        viewBox: "0 0 24 24",
        style: {
            animationName: "rotate",
            animationDuration: "4s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            transformOrigin: "center",
        },
    },
    _a[IconType.Save] = {
        data: "M6 24h12v-6h-12v6zM20 24h2v-14c0-0.297-0.266-0.938-0.469-1.141l-4.391-4.391c-0.219-0.219-0.828-0.469-1.141-0.469v6.5c0 0.828-0.672 1.5-1.5 1.5h-9c-0.828 0-1.5-0.672-1.5-1.5v-6.5h-2v20h2v-6.5c0-0.828 0.672-1.5 1.5-1.5h13c0.828 0 1.5 0.672 1.5 1.5v6.5zM14 9.5v-5c0-0.266-0.234-0.5-0.5-0.5h-3c-0.266 0-0.5 0.234-0.5 0.5v5c0 0.266 0.234 0.5 0.5 0.5h3c0.266 0 0.5-0.234 0.5-0.5zM24 10v14.5c0 0.828-0.672 1.5-1.5 1.5h-21c-0.828 0-1.5-0.672-1.5-1.5v-21c0-0.828 0.672-1.5 1.5-1.5h14.5c0.828 0 1.969 0.469 2.562 1.062l4.375 4.375c0.594 0.594 1.062 1.734 1.062 2.562z",
        viewBox: "0 0 24 28",
    },
    _a[IconType.Download] = {
        viewBox: "0 0 20 20",
        data: "M2 16.4h16V18H2zM8.4 2v6.4H5.2l4.8 6.4 4.8-6.4h-3.2V2z",
    },
    _a[IconType.Pencil] = {
        data: "M0 23l14.75-14.75 5 5-14.75 14.75h-5v-5zM23.625 9.375l-2.438 2.438-5-5 2.438-2.438q0.375-0.375 0.938-0.375t0.938 0.375l3.125 3.125q0.375 0.375 0.375 0.938t-0.375 0.938z",
        viewBox: "0 0 24 32",
    },
    _a[IconType.Document] = {
        data: "M19 3h-9.991c-1.109 0-2.009 0.898-2.009 2.007v22.985c0 1.109 0.891 2.007 1.997 2.007h15.005c1.103 0 1.997-0.891 1.997-1.997v-17.003h-4.994c-1.108 0-2.006-0.887-2.006-1.998v-6.002zM20 3v5.997c0 0.554 0.451 1.003 0.991 1.003h5.009l-6-7z",
        viewBox: "0 0 32 32",
    },
    _a[IconType.Dollar] = {
        data: "M15.281 18.516c0 3.187-2.281 5.703-5.594 6.25v2.734c0 0.281-0.219 0.5-0.5 0.5h-2.109c-0.266 0-0.5-0.219-0.5-0.5v-2.734c-3.656-0.516-5.656-2.703-5.734-2.797-0.156-0.187-0.172-0.453-0.031-0.641l1.609-2.109c0.078-0.109 0.219-0.172 0.359-0.187s0.281 0.031 0.375 0.141c0.031 0.016 2.219 2.109 4.984 2.109 1.531 0 3.187-0.812 3.187-2.578 0-1.5-1.844-2.234-3.953-3.078-2.812-1.109-6.312-2.516-6.312-6.438 0-2.875 2.25-5.25 5.516-5.875v-2.812c0-0.281 0.234-0.5 0.5-0.5h2.109c0.281 0 0.5 0.219 0.5 0.5v2.75c3.172 0.359 4.859 2.078 4.922 2.141 0.156 0.172 0.187 0.406 0.078 0.594l-1.266 2.281c-0.078 0.141-0.203 0.234-0.359 0.25-0.156 0.031-0.297-0.016-0.422-0.109-0.016-0.016-1.906-1.687-4.25-1.687-1.984 0-3.359 0.984-3.359 2.406 0 1.656 1.906 2.391 4.125 3.25 2.875 1.109 6.125 2.375 6.125 6.141z",
        viewBox: "0 0 16 28",
    },
    _a[IconType.Tools] = {
        data: "M27.783 7.936c0.959 2.313 0.502 5.074-1.379 6.955-2.071 2.071-5.201 2.395-7.634 1.022l-1.759 1.921 1.255 1.26 0.75-0.75c0.383-0.384 1.005-0.384 1.388 0l6.082 6.144c0.384 0.383 0.384 1.005 0 1.388l-2.776 2.776c-0.383 0.384-1.005 0.384-1.388 0l-6.082-6.144c-0.384-0.383-0.384-1.005 0-1.388l0.685-0.685-1.196-1.199-8.411 9.189c-0.767 0.767-2.010 0.767-2.776 0l-0.694-0.694c-0.767-0.767-0.767-2.010 0-2.776l9.582-8.025-6.364-6.381-2.010-0.001-2.326-3.74 1.872-1.875 3.825 2.341 0.025 1.968 6.438 6.463 1.873-1.568c-1.831-2.496-1.64-6.012 0.616-8.268 1.872-1.872 4.618-2.337 6.925-1.396l-4.124 4.067 3.471 3.471 4.132-4.075zM6.15 25.934c-0.383-0.383-1.004-0.383-1.388 0-0.384 0.384-0.384 1.005 0 1.389 0.384 0.383 1.005 0.383 1.388 0 0.384-0.385 0.384-1.006 0-1.389z",
        viewBox: "0 0 32 32",
    },
    _a[IconType.Transport] = {
        data: "M32 18l-4-8h-6v-4c0-1.1-0.9-2-2-2h-18c-1.1 0-2 0.9-2 2v16l2 2h2.536c-0.341 0.588-0.536 1.271-0.536 2 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.729-0.196-1.412-0.536-2h11.073c-0.341 0.588-0.537 1.271-0.537 2 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.729-0.196-1.412-0.537-2h2.537v-6zM22 18v-6h4.146l3 6h-7.146z",
        viewBox: "0 0 32 32",
    },
    _a[IconType.Filter] = {
        data: "M4.618 10l2.639-1.667V5.667L11.875 0H0l4.618 5.667z",
        viewBox: "0 0 12 10",
    },
    _a[IconType.Plus] = {
        data: "M14 8H8v6H6V8H0V6h6V0h2v6h6z",
        viewBox: "0 0 14 14",
    },
    _a[IconType.Success] = {
        data: "M12 0A12 12 0 1 0 12 24A12 12 0 1 0 12 0Z M7.5 11.42l-1.5 1.5 3.961 3.963 7.382-7.383-1.5-1.5-5.882 5.883z",
        viewBox: "0 0 24 24",
        style: { fill: "#009369", fillRule: "evenodd" },
    },
    _a[IconType.Warning] = {
        data: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z",
        viewBox: "0 0 24 24",
        style: { fill: "#D71B21" },
    },
    _a[IconType.HelpLight] = {
        data: "M10 0A10 10 0 1 0 10 20A10 10 0 1 0 10 0Z M9.25 15v-1.5h1.5V15h-1.5zM10 5a3 3 0 0 1 3 3c0 1.875-2.25 2.063-2.25 3.75h-1.5C9.25 9.312 11.5 9.5 11.5 8c0-.825-.675-1.5-1.5-1.5S8.5 7.175 8.5 8H7a3 3 0 0 1 3-3z",
        viewBox: "0 0 20 20",
        style: { fill: "#cbcbcb", backgroundColor: "white", borderRadius: "100px" },
    },
    _a[IconType.Search] = {
        data: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z",
        viewBox: "0 0 24 24",
    },
    _a[IconType.Help] = {
        data: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11.25 17v-1.5h1.5V17h-1.5zM12 7a3 3 0 0 1 3 3c0 1.875-2.25 2.063-2.25 3.75h-1.5c0-2.438 2.25-2.25 2.25-3.75 0-.825-.675-1.5-1.5-1.5s-1.5.675-1.5 1.5H9a3 3 0 0 1 3-3z",
        viewBox: "0 0 24 24",
        style: { stroke: "#1F3B80", strokeWidth: ".5" },
    },
    _a[IconType.Print] = {
        data: "M6 3v3h12V3H6zM5 8c-1.65 0-3 1.35-3 3v6h4v4h12v-4h4v-6c0-1.65-1.35-3-3-3H5zm14 2c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zM8 14h8v5H8v-5z",
        viewBox: "0 0 24 24",
    },
    _a[IconType.Note] = {
        data: "M10.001 7.8c-1.215 0-2.201 0.985-2.201 2.2s0.986 2.2 2.201 2.2c1.215 0 2.199-0.985 2.199-2.2s-0.984-2.2-2.199-2.2zM3.001 7.8c-1.215 0-2.201 0.985-2.201 2.2s0.986 2.2 2.201 2.2c1.215 0 2.199-0.986 2.199-2.2s-0.984-2.2-2.199-2.2zM17.001 7.8c-1.215 0-2.201 0.985-2.201 2.2s0.986 2.2 2.201 2.2c1.215 0 2.199-0.985 2.199-2.2s-0.984-2.2-2.199-2.2z",
        viewBox: "0 0 20 20",
    },
    _a[IconType.HelpThin] = {
        data: "M16 29C8.82 29 3 23.18 3 16S8.82 3 16 3s13 5.82 13 13-5.82 13-13 13zm0-2c6.075 0 11-4.925 11-11S22.075 5 16 5 5 9.925 5 16s4.925 11 11 11z M15 22.667v-2h2v2h-2zm1-13.334c2.21 0 4 1.79 4 4 0 2.5-3 2.75-3 5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4z",
        viewBox: "0 0 32 32",
        style: { fill: "#1f3b80" },
    },
    _a[IconType.Phone] = {
        data: "M8.672 3a2.35 2.35 0 0 0-1.465.53l-.063.031-.03.031-3.12 3.212.032.032a3.127 3.127 0 0 0-.842 3.367c.004.008-.004.024 0 .032.846 2.42 3.01 7.094 7.235 11.32 4.24 4.24 8.977 6.318 11.32 7.234h.03a3.582 3.582 0 0 0 3.462-.686l3.15-3.15c.826-.826.826-2.26 0-3.087l-4.055-4.054-.03-.062c-.827-.827-2.293-.827-3.12 0l-1.995 1.995a16.142 16.142 0 0 1-4.085-2.806c-1.633-1.56-2.467-3.352-2.775-4.054l1.996-1.996c.838-.838.853-2.233-.032-3.056l.032-.03-.094-.094-3.991-4.117-.032-.03-.062-.032A2.35 2.35 0 0 0 8.672 3zm0 1.996a.35.35 0 0 1 .219.093l3.991 4.085.094.094c-.008-.008.058.097-.063.218l-2.494 2.495-.468.436.218.624s1.146 3.068 3.555 5.364l.218.187c2.32 2.116 5.052 3.274 5.052 3.274l.624.28 2.962-2.962c.172-.171.14-.171.312 0l4.085 4.085c.171.172.171.11 0 .28l-3.056 3.057c-.46.393-.947.475-1.528.28-2.26-.888-6.654-2.818-10.571-6.735-3.949-3.949-6.01-8.427-6.767-10.602-.152-.406-.043-1.006.312-1.31l.062-.063L8.454 5.09a.35.35 0 0 1 .218-.093z",
        viewBox: "0 0 32 32",
    },
    _a[IconType.Mail] = {
        data: "M3 7v18h26V7H3zm4.313 2h17.375L16 14.781 7.312 9zM5 9.875l10.438 6.969.562.343.563-.343L27 9.875V23H5V9.875z",
        viewBox: "0 0 32 32",
    },
    _a[IconType.SmileyVeryBad] = {
        data: "M24 8C15.177 8 8 15.177 8 24s7.177 16 16 16 16-7.177 16-16S32.823 8 24 8zm0 2.667c7.38 0 13.333 5.953 13.333 13.333S31.38 37.333 24 37.333A13.312 13.312 0 0 1 10.667 24c0-7.38 5.953-13.333 13.333-13.333zm-6 8a2 2 0 1 0 .001 4 2 2 0 0 0-.001-4zm12 0a2 2 0 1 1-.001 4 2 2 0 0 1 .001-4zM17 32s1.605-5 7-5 7 5 7 5H17z",
        viewBox: "0 0 48 48",
    },
    _a[IconType.SmileyBad] = {
        data: "M24 8C15.177 8 8 15.177 8 24s7.177 16 16 16 16-7.177 16-16S32.823 8 24 8zm0 2.667c7.38 0 13.333 5.953 13.333 13.333S31.38 37.333 24 37.333A13.312 13.312 0 0 1 10.667 24c0-7.38 5.953-13.333 13.333-13.333zm-6 8a2 2 0 1 0 .001 4 2 2 0 0 0-.001-4zm12 0a2 2 0 1 0 .001 4 2 2 0 0 0-.001-4zm-6 8c-3.557 0-6.693 1.78-8.625 4.458l2.167 1.542c1.453-2.021 3.78-3.334 6.458-3.334 2.677 0 5.005 1.313 6.458 3.334l2.167-1.542c-1.932-2.677-5.068-4.458-8.625-4.458z",
        viewBox: "0 0 48 48",
    },
    _a[IconType.SmileyNeutral] = {
        data: "M24 8C15.177 8 8 15.177 8 24s7.177 16 16 16 16-7.177 16-16S32.823 8 24 8zm0 2.667c7.38 0 13.333 5.953 13.333 13.333S31.38 37.333 24 37.333A13.312 13.312 0 0 1 10.667 24c0-7.38 5.953-13.333 13.333-13.333zm-6 8a2 2 0 1 0 .001 4 2 2 0 0 0-.001-4zm12 0a2 2 0 1 1-.001 4 2 2 0 0 1 .001-4zM16 27h16v2.7H16V27z",
        viewBox: "0 0 48 48",
    },
    _a[IconType.SmileyGood] = {
        data: "M24 8C15.177 8 8 15.177 8 24s7.177 16 16 16 16-7.177 16-16S32.823 8 24 8zm0 2.667c7.38 0 13.333 5.953 13.333 13.333S31.38 37.333 24 37.333A13.312 13.312 0 0 1 10.667 24c0-7.38 5.953-13.333 13.333-13.333zm-6 8a2 2 0 1 0 .001 4 2 2 0 0 0-.001-4zm12 0a2 2 0 1 0 .001 4 2 2 0 0 0-.001-4zM17.083 28l-2.291 1.333c1.843 3.183 5.27 5.334 9.208 5.334 3.938 0 7.365-2.151 9.208-5.334L30.917 28c-1.386 2.39-3.948 4-6.917 4s-5.531-1.61-6.917-4z",
        viewBox: "0 0 48 48",
    },
    _a[IconType.SmileyVeryGood] = {
        data: "M24 8C15.177 8 8 15.177 8 24s7.177 16 16 16 16-7.177 16-16S32.823 8 24 8zm0 2.667c7.38 0 13.333 5.953 13.333 13.333S31.38 37.333 24 37.333A13.312 13.312 0 0 1 10.667 24c0-7.38 5.953-13.333 13.333-13.333zm-9.333 10.666V24h6.666v-2.667h-6.666zm12 0V24h6.666v-2.667h-6.666zm-12 6.667s2.14 6.667 9.333 6.667S33.333 28 33.333 28H14.667z",
        viewBox: "0 0 48 48",
    },
    _a[IconType.Spinner] = {
        data: "M28 45c13.255 0 24-10.745 24-24S41.255-3 28-3 4 7.745 4 21s10.745 24 24 24z",
        viewBox: "0 -7 56 56",
        style: {
            strokeDasharray: "167px",
            strokeLinecap: "round",
            strokeWidth: "8px",
            fillRule: "evenodd",
            fill: "none",
            stroke: "#00aacd",
            animationName: "rotateSpinner",
            animationDuration: "4s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            transformOrigin: "50% 37.6%",
        },
    },
    _a[IconType.ArrowBottom] = {
        data: "M7.5 8L6 9.5l6.07 6.07 6.07-6.07-1.5-1.5-4.57 4.57z",
        viewBox: "0 0 24 24",
    },
    _a[IconType.ArrowLeft] = {
        data: "M16 7.5L14.5 6l-6.07 6.07 6.07 6.07 1.5-1.5-4.57-4.57z",
        viewBox: "0 0 24 24",
    },
    _a[IconType.ArrowRight] = {
        data: "M8 7.5L9.5 6l6.07 6.07-6.07 6.07-1.5-1.5 4.57-4.57z",
        viewBox: "0 0 24 24",
    },
    _a[IconType.ArrowTop] = {
        data: "M7.5 16L6 14.5l6.07-6.07 6.07 6.07-1.5 1.5-4.57-4.57z",
        viewBox: "0 0 24 24",
    },
    _a[IconType.ArrowSubmenu] = {
        data: "M4.5 5L9 0H0z",
        viewBox: "0 0 9 5",
    },
    _a[IconType.ArrowTopRight] = {
        data: "M0.7,11.6v14.8h37.5l-8.9,8.9l3.5,3.5L47.7,24L32.8,9.2l-3.5,3.5l8.9,8.9H5.6v-9.9L0.7,11.6z",
        viewBox: "0 0 48 48",
    },
    _a[IconType.SortArrowUp] = {
        data: "M4.5 0L9 5H0z",
        viewBox: "0 -2 9 14",
    },
    _a[IconType.SortArrowDown] = {
        data: "M4.5 5L9 0H0z",
        viewBox: "0 -7 9 14",
    },
    _a[IconType.SortArrowBoth] = {
        data: "M4.5 0L9 5H0l4.5-5zm0 14L0 9h9l-4.5 5z",
        viewBox: "0 0 9 14",
    },
    _a[IconType.Info] = {
        data: "M224 152c0-13.2 10.8-24 24-24h16c13.2 0 24 10.8 24 24v16c0 13.2-10.8 24-24 24h-16c-13.2 0-24-10.8-24-24v-16z M320 384h-128v-32h32v-96h-32v-32h96v128h32z M256 0c-141.385 0-256 114.615-256 256s114.615 256 256 256 256-114.615 256-256-114.615-256-256-256zM256 464c-114.875 0-208-93.125-208-208s93.125-208 208-208 208 93.125 208 208-93.125 208-208 208z",
        viewBox: "0 0 512 512",
    },
    _a[IconType.Exit] = {
        data: "M24 20v-4h-10v-4h10v-4l6 6zM22 18v8h-10v6l-12-6v-26h22v10h-2v-8h-16l8 4v18h8v-6z",
        viewBox: "0 0 32 32",
    },
    _a);
var iconComponent = function (props) {
    var width = props.width, height = props.height, icon = props.icon, className = props.className, style = props.style, onClick = props.onClick;
    var _a = ICONS[icon], viewBox = _a.viewBox, data = _a.data, iconStyle = _a.style;
    return (react_1.default.createElement("svg", { width: width || 18, height: height || 18, viewBox: viewBox || "0 0 32 32", className: classnames_1.default("respectkit__icon", className), style: style, onClick: onClick },
        react_1.default.createElement("path", { d: data, style: iconStyle })));
};
exports.default = iconComponent;
//# sourceMappingURL=index.js.map